import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useInView } from '@/hooks/useInView';

export const StandardsSection = ({ t }) => {
  const [ref, isInView] = useInView();

  return (
    <section id="standards" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50" data-testid="standards-section">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-testid="standards-title">{t.standards.title}</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-testid="standards-subtitle">
            {t.standards.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {t.standards.items.map((standard, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 text-center transform hover:scale-105"
              data-testid={`standard-card-${index}`}
            >
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="text-white" size={32} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-testid={`standard-name-${index}`}>{standard.name}</h3>
              <p className="text-sm text-gray-600" data-testid={`standard-description-${index}`}>{standard.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
